import React, { useEffect, useState } from 'react'
import { Badge, Avatar, List, Button, Popover } from 'antd'
import {
  MailOutlined,
  BellOutlined,
  WarningOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons'
import NavItem from './NavItem'
import Flex from 'components/shared-components/Flex'
import IdentityService from 'services/IdentityService'
import { env } from 'configs/EnvironmentConfig'
import { App } from 'antd'
import { EmptyNotifications } from 'assets/svg/icon'

const getNotificationIcon = {
  success: <MailOutlined />,
  warning: <WarningOutlined />,
  error: <CheckCircleOutlined />,
  default: <MailOutlined />,
}

const getNotificationBody = list => {
  return list?.length > 0 ? (
    <List
      size="small"
      itemLayout="horizontal"
      dataSource={list}
      renderItem={data => (
        <List.Item className="list-clickable">
          <Flex alignItems="center">
            <div className="pr-3">
              <Avatar icon={getNotificationIcon[data?.status]} />
            </div>

            <div className="mr-3">
              <span className="font-weight-bold text-dark">{data?.title} </span>
              <span className="text-gray-light">{data?.description}</span>
            </div>

            <small className="ml-auto">{data?.date}</small>
          </Flex>
        </List.Item>
      )}
    />
  ) : (
    <div className="empty-notification p-4 d-flex flex-column align-items-center">
      <EmptyNotifications width={79} heoght={75} color="currentColor" />

      <p className="m-0 mt-3 text-center">Você não tem nenhuma notificação.</p>
    </div>
  )
}

export const NavNotification = ({ mode }) => {
  const [data, setData] = useState(null)
  const [token, setToken] = useState(null)
  const { notification } = App.useApp()

  const getWebNotifyToken = async () => {
    const data = await IdentityService.webNotifyToken()

    if (data) {
      setToken(data.token)
    }
  }

  // useEffect(() => {
  //   getWebNotifyToken()
  // }, [])

  useEffect(() => {
    if (token) {
      alert(token)
      const eventSource = new EventSource(
        `${env.WEB_NOTIFY_ENDPOINT_URL}?token=${token}`
      )

      eventSource.addEventListener('message', e => {
        const data = JSON.parse(e.data)
        const payload = JSON.parse(data?.Payload)

        notification.open({
          key: data?.Id,
          type: payload?.status.toLowerCase(),
          message: payload?.title,
          description: payload?.description,
          duration: 2,
        })
      })

      eventSource.addEventListener('error', () => {
        eventSource.close()
      })

      return () => eventSource.close()
    }
  }, [notification, token])

  const notificationList = (
    <div>
      <div className="border-bottom d-flex justify-content-between align-items-center px-3 py-2">
        <h4 className="mb-0">Notificação</h4>

        <Button
          className="text-primary"
          type="text"
          onClick={() => setData([])}
          size="small"
        >
          Marcar como lidas
        </Button>
      </div>

      <div className="nav-notification-body">{getNotificationBody(data)}</div>

      {data?.length > 0 ? (
        <div className="px-3 py-2 border-top text-center">
          <a className="d-block" href="#/">
            Carregar mais
          </a>
        </div>
      ) : null}
    </div>
  )

  return (
    <Popover
      placement="bottomRight"
      content={notificationList}
      trigger="click"
      overlayClassName="nav-notification"
      overlayInnerStyle={{ padding: 0, width: 364, maxWidth: '100%' }}
      overlayStyle={{ maxWidth: '100%' }}
    >
      <NavItem mode={mode}>
        <Badge count={data?.length}>
          {mode === true ? (
            <BellOutlined className="nav-icon mx-auto" />
          ) : (
            <BellOutlined
              className="nav-icon mx-auto"
              style={{ color: 'black' }}
            />
          )}
        </Badge>
      </NavItem>
    </Popover>
  )
}

export default NavNotification
